// A link to a spot inside a closed fold (<details>) opens the fold on the way, in every browser, not only the ones that
// do it themselves; so does a page opened at that spot (#fit-steps) or sent there by Back and Forward.
const openTo = (id) => {
  const spot = id && document.getElementById(id)
  for (let fold = spot?.closest("details"); fold; fold = fold.parentElement?.closest("details")) fold.open = true
  return spot
}

document.addEventListener("click", (event) => {
  const link = event.target.closest?.('a[href^="#"]')
  if (link && link.hash.length > 1) openTo(decodeURIComponent(link.hash.slice(1)))
})
const fromAddress = () => location.hash.length > 1 && openTo(decodeURIComponent(location.hash.slice(1)))?.scrollIntoView()
window.addEventListener("hashchange", fromAddress)
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fromAddress, { once: true })
else fromAddress()
